export default __webpack_public_path__ + "static/media/privacy-settings-modal-BG.3e076205.png";